export default {
    methods: {
        //FILES
        setFiles(files) {
            this.l_files = files;
        },
        getFiles() {
            return this.l_files;
        }
    }
}
